(function(){
  function initDescriptions(scope){
    var roots = (scope || document).querySelectorAll('[data-hb-product-description]');

    roots.forEach(function(root){
      var content = root.querySelector('[data-hb-product-description-content]');
      var toggle = root.querySelector('[data-hb-product-description-toggle]');

      if (!content || !toggle) {
        return;
      }

      var collapsedHeight = parseInt(root.style.getPropertyValue('--hb-product-description-collapsed-height'), 10) || 280;
      var shouldCollapse = content.scrollHeight > collapsedHeight + 12;
      var isExpanded = root.classList.contains('is-expanded');

      root.classList.toggle('hb-product-description--has-toggle', shouldCollapse);
      root.classList.toggle('is-collapsed', shouldCollapse && !isExpanded);
      root.classList.toggle('is-expanded', shouldCollapse && isExpanded);
      toggle.hidden = !shouldCollapse;
      toggle.setAttribute('aria-expanded', shouldCollapse && isExpanded ? 'true' : 'false');
      toggle.textContent = shouldCollapse && isExpanded ? toggle.getAttribute('data-collapse-label') : toggle.getAttribute('data-expand-label');
    });
  }

  function initReturnLinks(scope){
    var links = (scope || document).querySelectorAll('[data-hb-product-return-link]');

    links.forEach(function(link){
      if (link.getAttribute('data-use-referrer') !== 'true' || !document.referrer) {
        return;
      }

      try {
        var referrer = new URL(document.referrer);
        var isCollectionPath = referrer.origin === window.location.origin &&
          referrer.pathname.indexOf('/collections/') === 0;

        if (!isCollectionPath) {
          return;
        }

        var productPathIndex = referrer.pathname.indexOf('/products/');
        var listingPath = productPathIndex === -1
          ? referrer.pathname + referrer.search + referrer.hash
          : referrer.pathname.slice(0, productPathIndex);

        if (listingPath === '/collections' || listingPath === '/collections/') {
          return;
        }

        link.href = listingPath;

        var label = link.querySelector('[data-hb-product-return-label]');
        if (label && link.getAttribute('data-referrer-label')) {
          label.textContent = link.getAttribute('data-referrer-label');
        }
      } catch (error) {
        return;
      }
    });
  }

  function bindDescriptionToggles(scope){
    var toggles = (scope || document).querySelectorAll('[data-hb-product-description-toggle]');

    toggles.forEach(function(toggle){
      if (toggle.hasAttribute('data-hb-bound')) {
        return;
      }

      toggle.setAttribute('data-hb-bound', 'true');
      toggle.addEventListener('click', function(){
        var root = toggle.closest('[data-hb-product-description]');
        if (!root) {
          return;
        }

        var isExpanded = root.classList.toggle('is-expanded');
        root.classList.toggle('is-collapsed', !isExpanded);
        toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        toggle.textContent = isExpanded ? toggle.getAttribute('data-collapse-label') : toggle.getAttribute('data-expand-label');
      });
    });
  }

  function initMobileAtc(scope){
    var bars = (scope || document).querySelectorAll('[data-hb-mobile-atc]');

    bars.forEach(function(bar){
      if (bar.hasAttribute('data-hb-bound')) {
        return;
      }

      var formId = bar.getAttribute('data-source-form');
      var form = formId ? document.getElementById(formId) : null;
      var sourceButton = form ? form.querySelector('[data-add-to-cart]') : document.querySelector('[data-add-to-cart]');
      var sourceText = sourceButton ? sourceButton.querySelector('[data-add-to-cart-text]') : null;
      var sourcePrice = document.querySelector('[data-product-price]');
      var barButton = bar.querySelector('[data-hb-mobile-atc-button]');
      var barText = bar.querySelector('[data-hb-mobile-atc-text]');
      var barPrice = bar.querySelector('[data-hb-mobile-atc-price]');
      var barQuantity = bar.querySelector('[data-hb-mobile-atc-quantity]');
      var barQuantityMinus = bar.querySelector('[data-hb-mobile-atc-quantity-minus]');
      var barQuantityPlus = bar.querySelector('[data-hb-mobile-atc-quantity-plus]');
      var defaultText = sourceText ? sourceText.getAttribute('data-default-text') : '';
      var initialText = barText ? barText.textContent : '';

      if (!form || !sourceButton || !barButton) {
        return;
      }

      function normalizeQuantity(value){
        var quantity = parseInt(value, 10);
        return Number.isNaN(quantity) || quantity < 1 ? 1 : quantity;
      }

      function getFormQuantity(){
        var input = form.querySelector('input[name="quantity"]');

        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'quantity';
          input.value = '1';
          form.appendChild(input);
        }

        return input;
      }

      function syncQuantityToForm(){
        if (!barQuantity) {
          return;
        }

        var quantity = normalizeQuantity(barQuantity.value);
        barQuantity.value = quantity;
        getFormQuantity().value = quantity;
      }

      function sync(){
        var isDisabled = sourceButton.disabled || sourceButton.classList.contains('disabled');
        var isLoading = sourceButton.classList.contains('btn--loading');

        barButton.disabled = isDisabled;
        barButton.classList.toggle('is-loading', isLoading);

        if (barText) {
          var nextText = sourceText ? sourceText.textContent : '';
          barText.textContent = nextText.trim() || defaultText || initialText;
        }

        if (barPrice && sourcePrice) {
          barPrice.textContent = sourcePrice.textContent;
        }
      }

      bar.setAttribute('data-hb-bound', 'true');

      if (barQuantity) {
        var sourceQuantity = form.querySelector('input[name="quantity"]');
        if (sourceQuantity) {
          barQuantity.value = normalizeQuantity(sourceQuantity.value);
        }

        barQuantity.addEventListener('change', syncQuantityToForm);
        barQuantity.addEventListener('blur', syncQuantityToForm);
        barQuantity.addEventListener('input', function(){
          var value = barQuantity.value.replace(/[^0-9]/g, '');

          if (value === '') {
            barQuantity.value = '';
            return;
          }

          barQuantity.value = normalizeQuantity(value);
          getFormQuantity().value = barQuantity.value;
        });
      }

      if (barQuantityMinus) {
        barQuantityMinus.addEventListener('click', function(){
          barQuantity.value = Math.max(1, normalizeQuantity(barQuantity.value) - 1);
          syncQuantityToForm();
        });
      }

      if (barQuantityPlus) {
        barQuantityPlus.addEventListener('click', function(){
          barQuantity.value = normalizeQuantity(barQuantity.value) + 1;
          syncQuantityToForm();
        });
      }

      barButton.addEventListener('click', function(){
        if (barButton.disabled) {
          return;
        }

        syncQuantityToForm();

        if (form.requestSubmit) {
          form.requestSubmit(sourceButton);
        } else {
          sourceButton.click();
        }
      });

      var observer = new MutationObserver(sync);
      observer.observe(sourceButton, { attributes:true, childList:true, subtree:true });
      if (sourcePrice) {
        observer.observe(sourcePrice, { childList:true, subtree:true });
      }

      document.addEventListener('ajaxProduct:added', sync);
      document.addEventListener('variantChange', sync);
      syncQuantityToForm();
      sync();
    });
  }

  function init(scope){
    initDescriptions(scope);
    bindDescriptionToggles(scope);
    initReturnLinks(scope);
    initMobileAtc(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function(event){
    init(event.target);
  });

  window.addEventListener('resize', function(){
    initDescriptions(document);
  });
})();
